import Grid from '@mui/material/Grid';
import { CajasProvider } from "src/context/CajasContext/CajasContext";
import { CajasGenericasAsignacionList } from "../components/CajasGenericasAsignacionList";
import { PageHeaderCard } from "src/general_components/PageHeaderCard";
import CategoryIcon from "@mui/icons-material/Category";

export function CajasGenericasAsignacion() {
  return (
    <Grid style={{ marginBottom: "50px", paddingTop: 10 }}>
      <PageHeaderCard title="Asignación de Cajas Genéricas" icon={<CategoryIcon />} />
      <CajasProvider>
        <Grid>
          <CajasGenericasAsignacionList />
        </Grid>
      </CajasProvider>
    </Grid>
  );
}
